import {
  BorderStyle,
  Col,
  Color,
  AlignItems,
  Box,
  Display,
  FlexDirection,
  Heading1,
  JustifyContent,
  Grid,
} from '@gousto-internal/citrus-react'

import { useDashboardExperience } from './hooks/useDashboardExperience'
import { Notification } from './components/Notification'
import React from 'react'
import { OrderTabs } from './components/OrderTabs'

export function MyHomePage() {
  const { page_title, order_tabs, error } = useDashboardExperience()

  return (
    <main data-testid="my-home-page-main">
      <Box
        maxWidth="1200px"
        style={{ margin: '0 auto' }}
        display={Display.Flex}
        flexDirection={FlexDirection.Column}
        alignItems={AlignItems.FlexStart}
        gap={[4, 6]}
        paddingV={[4, 6]}
        paddingH={[3, 0]}
      >
        <Box
          width="100%"
          minHeight={['52px', '40px']}
          display={Display.Flex}
          alignItems={AlignItems.Center}
          justifyContent={JustifyContent.FlexStart}
          paddingV={[3, 1]}
          paddingH={[3, 0]}
          data-testid="my-home-page-title-box"
        >
          {error ? (
            <Notification
              state="error"
              message="Oops something went wrong. Please try again later."
            />
          ) : (
            <Heading1>{page_title}</Heading1>
          )}
        </Box>

        <Grid gap={[4, 3]} width={'100%'}>
          <Col size={[12, null, null, 2]} display={[Display.None, null, null, Display.Block]}>
            <Box>
              <section aria-label="order-tabs">
                <Box>
                  <OrderTabs orderTabs={order_tabs} />
                </Box>
              </section>
            </Box>
          </Col>
          <Col size={[12, null, null, 10]}>
            <Box
              borderWidth={1}
              borderStyle={BorderStyle.Solid}
              borderColor={Color.ColdGrey_100}
              bg={Color.White}
              style={{ cursor: 'pointer', borderRadius: '4px' }}
            >
              <section aria-label="Right column">
                <p>Right column content</p>
              </section>
            </Box>
          </Col>
        </Grid>
      </Box>
    </main>
  )
}
